import { render, staticRenderFns } from "./EmployeeContactEditor.vue?vue&type=template&id=5ccc22ef&scoped=true&"
import script from "./EmployeeContactEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeeContactEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeContactEditor.vue?vue&type=style&index=0&id=5ccc22ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc22ef",
  null
  
)

export default component.exports